export const ERROR_SF_TRANSLATION_NAMESPACE = "error-sales-force";

export const ERROR_SF_DOWN_TK = "ERROR_SF_DOWN_TK";
